"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEntityFromElement_1 = require("./getEntityFromElement");
var EntityInfo_1 = require("./EntityInfo");
/**
 * Get all entities with given entity type and id from an editor
 * @param editor The editor to get entity from
 * @param type (Optional) Type of the entity. If not specified, it will return all entities from this editor
 * @param id (Optional) Id of the entity. If not specified, it will return all entities of the given type
 */
function getEntities(editor, type, id) {
    var selector = EntityInfo_1.getEntitySelector(type, id);
    var nodes = editor.queryElements(selector);
    var allEntities = nodes.map(function (node) { return getEntityFromElement_1.default(node); });
    return allEntities.filter(function (e) { return !!e; });
}
exports.default = getEntities;
//# sourceMappingURL=getEntities.js.map